import clsx from "clsx";

const Typography = (props) => {
    const { variant, ...other } = props;
    const normalizedValue = variant ? variant.toLowerCase() : variant;

    switch (normalizedValue) {
        case "h1":
            return <h1 {...other} />;

        case "h2":
            return <h2 {...other} />;

        case "h3":
            return <h3 {...other} />;

        case "h4":
            return <h4 {...other} />;

        case "h5":
            return <h5 {...other} />;

        case "h6":
            return <h6 {...other} />;

        case "subtitle1":
            return (
                <span
                    {...other}
                    className={clsx("subtitle1", other.className)}
                />
            );

        case "subtitle2":
            return (
                <span
                    {...other}
                    className={clsx("subtitle2", other.className)}
                />
            );

        case "body2":
            return (
                <span {...other} className={clsx("body2", other.className)} />
            );

        case "caption":
            return (
                <span {...other} className={clsx("caption", other.className)} />
            );

        case "overline":
            return (
                <span
                    {...other}
                    className={clsx("overline", other.className)}
                />
            );

        default:
            return (
                <span {...other} className={clsx("body1", other.className)} />
            );
    }
};

export default Typography;
